export default __webpack_public_path__ + "static/media/link4.bdaf2b4c.svg";